import React, { useMemo } from 'react';
import { SlidersHorizontal } from 'lucide-react';
import StatusCard from './StatusCard';
// import SectionHeader from './SectionHeader';
import { useDashboardStore } from '../../../stores/dashboard-store';
import { useLanguage } from '../../../contexts/LanguageContext';
import { OnItsWayIcon, PaymentUnverifiedIcon, PendingItemCompletionIcon } from '../../../components/icons/DashboardIcons';

const WorkplaceShippingSection: React.FC = () => {
  const { stats } = useDashboardStore();
  const { t } = useLanguage();

  const getStatusValue = (statusKey: string): string => {
    const value = stats?.status_counts?.[statusKey];
    return value !== undefined ? value.toString() : '0';
  };

  const shippingCards = useMemo(() => [
    {
      title: t('dashboard.onItsWay'),
      value: getStatusValue('on-its-way'),
      change: '+5%',
      changeType: 'increase' as const,
      icon: OnItsWayIcon,
      color: 'purple',
      navigateTo: '/orders?tab=on_its_way'
    },
    {
      title: t('dashboard.delayed'),
      value: getStatusValue('delayed'),
      change: '+50%',
      changeType: 'increase' as const,
      icon: PendingItemCompletionIcon,
      color: 'red',
      navigateTo: '/orders?tab=delayed'
    },
    {
      title: t('dashboard.undelivered'),
      value: getStatusValue('unreceived'),
      change: '+50%',
      changeType: 'increase' as const,
      icon: PaymentUnverifiedIcon,
      color: 'orange',
      navigateTo: '/orders?tab=unreceived'
    }
  ], [stats, t]);

  return (
    <div>
      {/* Section with background covering title and controls */}
      <div className="rounded-lg bg-[#F1F1F4] p-3 md:p-4">
        {/* Section Header with Week button */}
        <div className="mb-3 flex items-center justify-between">
          <h2 className="text-[35px] font-medium leading-none text-[#24304F]">{t('dashboard.marketplaceShipping')}</h2>
          <button className="inline-flex items-center gap-1.5 rounded-md bg-[#DFE3EC] px-3 py-1.5 text-[13px] font-medium text-[#5D6680]">
            <SlidersHorizontal size={14} />
            {t('common.week')}
          </button>
        </div>
        
        {/* Cards */}
        <div className="space-y-3">
          {shippingCards.map((card, index) => (
            <StatusCard key={index} card={card} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default WorkplaceShippingSection;